import { IRelationMutation } from '../api/types/relation_mutation'
import { requestRelationMutation as requestRelationMutationApi, getPendingMutations as getPendingMutationsApi } from '../api/mutations'
import { useState } from 'react'
import { useAppDispatch, useAppSelector } from './state'
import { setPendingRelationMutations } from '../state/slices/relation_mutations_slice'
import { getResourceAuthorization } from '../state/selectors/resource_authorization'

export const useRelationMutation = () => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useAppDispatch()
  const resourceAuthorization = useAppSelector(getResourceAuthorization)

  const requestRelationMutation = async (
    refKey: string,
    relationNumber: number,
    relationData: IRelationMutation
  ) => await requestRelationMutationApi(refKey, relationNumber, relationData)

  const getPendingMutations = async () => {
    setIsLoading(true)
    try {
      const refKey = resourceAuthorization?.relationInfo?.agentNumber
      const relationNumber = resourceAuthorization?.relationInfo?.relationNumber

      if (!refKey || !relationNumber) {
        return
      }

      const { data }  = await getPendingMutationsApi(refKey, relationNumber)

      dispatch(setPendingRelationMutations(data))

      return true
    } catch (error) {
      return false
    } finally {
      setIsLoading(false)
    }
  }

  return {
    requestRelationMutation,
    getPendingMutations,
    isLoading
  }
}

export default useRelationMutation
